module.exports = __webpack_public_path__ + "img/ca55842.png";